// extracted by mini-css-extract-plugin
export var mt0 = "text-hero-module--mt-0--3b772";
export var mt1 = "text-hero-module--mt-1--6c519";
export var mt2 = "text-hero-module--mt-2--d0788";
export var mt3 = "text-hero-module--mt-3--99023";
export var mt4 = "text-hero-module--mt-4--87e3e";
export var mt5 = "text-hero-module--mt-5--d8dc6";
export var mt6 = "text-hero-module--mt-6--8784f";
export var textHero = "text-hero-module--text-hero--c69fb";
export var textHeroDark = "text-hero-module--text-hero--dark--58025";
export var textHeroFullbleed = "text-hero-module--text-hero--fullbleed--bb098";
export var textHero__body = "text-hero-module--text-hero__body--ed51b";
export var textHero__copy = "text-hero-module--text-hero__copy--6c5f4";
export var textHero__cta = "text-hero-module--text-hero__cta--1903d";
export var textHero__ctas = "text-hero-module--text-hero__ctas--2034e";
export var textHero__eyebrow = "text-hero-module--text-hero__eyebrow--46619";
export var textHero__headline = "text-hero-module--text-hero__headline--4e926";